// extracted by mini-css-extract-plugin
export default {"mCard":"xD-z","image":"yD-z","imageNoBackground":"zD-z","imageHasCategory":"AD-z","fullWidth":"BD-z"};